import { render, staticRenderFns } from "./shotPhotoStoreLuckybag.vue?vue&type=template&id=239c563a&"
import script from "./shotPhotoStoreLuckybag.vue?vue&type=script&lang=js&"
export * from "./shotPhotoStoreLuckybag.vue?vue&type=script&lang=js&"
import style0 from "./shotPhotoStoreLuckybag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports